import React, { useMemo } from 'react';
import { observer } from 'mobx-react';

import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  IconButton,
} from '@chakra-ui/react';
import { useStores } from 'hooks/useStores';
import Table from 'components/Table';

import { HiOutlineUserRemove } from 'react-icons/hi';

const PlayersListModal = ({ shortName, roomId, isOpen, onClose }) => {
  const {
    gamesStore: { roomPlayers, kickPlayerFromRoom },
  } = useStores();

  const onKickPlayer = async socketId => {
    await kickPlayerFromRoom(shortName, roomId, socketId);
  };

  const columns = useMemo(
    () => [
      { Header: 'Name', accessor: 'name' },
      { Header: 'Guest', accessor: r => r.guest.toString() },
      { Header: 'joinDate', accessor: 'joinDate' },
      { Header: 'points', accessor: 'points' },
      { Header: 'slot', accessor: 'slot' },
      {
        Header: 'kick',
        accessor: 'socketId',
        Cell: ({ value }) => (
          <IconButton
            variant="ghost"
            icon={<HiOutlineUserRemove />}
            onClick={() => onKickPlayer(value)}
          />
        ),
      },
    ],
    [roomId]
  );

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent width="fit-content" maxW="unset">
        <ModalHeader>{roomId} players</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Table
            {...{
              columns,
              data: roomPlayers.data,
            }}
          />
        </ModalBody>

        <ModalFooter>
          <Button colorScheme="blue" mr={3} onClick={onClose}>
            Close
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default observer(PlayersListModal);
